import Form from '../_form';

import debounce from '../../utils/debounce';

export default class ProjectsFilterForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        this.form.reset();

        const gthis = this;

        const search = this.form.querySelector('input[name="search"]');

        const handler = debounce(function () {
            gthis.finalizeForm();
        }, 300);

        ['input', 'change'].forEach((event) => {
            search.addEventListener(event, handler);
        });

        this.loader = document.querySelector('#projects-loader');
        this.grid = document.querySelector('#projects-grid');
        this.pagination = document.querySelector('#projects-pagination-wrapper');

        const interactiveFields = [...this.form.querySelectorAll('input:not([name="page"])')];
        const pageField = this.form.querySelector('input[name="page"]');

        ['input', 'change'].forEach((event) => {
            interactiveFields.forEach((field) => {
                field.addEventListener(event, () => {
                    pageField.value = 1;
                });
            });
        });
    }

    loaderShow () {
        if (this.loader) {
            this.loader.classList.remove('hidden');
            this.grid.classList.add('hidden');
            this.pagination.classList.add('hidden');
        }
    }

    loaderHide () {
        if (this.loader) {
            setTimeout(() => {
                this.loader.classList.add('hidden');
                this.grid.classList.remove('hidden');
                this.pagination.classList.remove('hidden');
            }, 1000);
        }
    }

    setupPagination () {
        const page = this.form.querySelector('input[name="page"]');

        const links = document.querySelectorAll('#projects-pagination *[data-page]');

        if (!links || !links.length) return;

        const clickable = [...links].filter((link) => !link.classList.contains('disabled') && !link.classList.contains('active'));

        if (!clickable || !clickable.length) return;

        clickable.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.stopPropagation();

                page.value = link.dataset.page;

                this.finalizeForm();

                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });

                    window.dispatchEvent(new Event('resize'));
                }, 300);
            });
        });
    }

    updateProjectsGrid(projectsHtml) {
        const grid = document.querySelector('#projects-grid');

        if (grid) grid.innerHTML = projectsHtml;
    }

    updatePagination(paginationHtml) {
        const pagination = document.querySelector('#projects-pagination');

        if (pagination) pagination.innerHTML = paginationHtml;

        setTimeout(() => this.setupPagination());
    }

    updateShowingInfo(showingInfoHtml) {
        const showingInfo = document.querySelector('#projects-count');

        if (showingInfo) showingInfo.innerHTML = showingInfoHtml;
    }

    async finalizeForm () {
        const gthis = this;

        const handler = debounce(async function () {
            gthis.loaderShow();

            const formData = new FormData(gthis.form);
            const params = new URLSearchParams();

            params.append('per-page', 9);

            formData.forEach((value, key) => {
                if (key.startsWith('category-') && value === 'on') {
                    params.append('categories[]', key.replace('category-', ''));
                } else {
                    params.append(key, value);
                }
            });

            try {
                await fetch(`/wp-json/projects/v1/filter?${params.toString()}`, {
                    method: 'GET'
                })
                .then((response) => response.json())
                .then((data) => {
                    if (data && !data.error) {
                        gthis.form.classList.remove('error');
                        gthis.form.classList.add('sent');

                        gthis.updateProjectsGrid(data.projects);
                        gthis.updatePagination(data.pagination);
                        gthis.updateShowingInfo(data.showingInfo);
                    } else {
                        gthis.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                        gthis.form.classList.add('error');
                    }
                })
                .catch(() => {
                    gthis.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                    gthis.form.classList.add('error');
                });

                gthis.loaderHide();
            } catch (error) {
                gthis.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                gthis.form.classList.add('error');

                gthis.loaderHide();
            }
        }, 300);

        handler();
    }
}
